import { IAction } from '../../base/interfaces/action';

export const EA_DOCU_ACTIONS: IAction[] = [
  {
    action: 'folder-add',
    menuIcon: 'folder-add',
    behavior: 'hide',
    types: ['actions', 'row'],
    menuText: 'actions.new_folder2',
    minSelected: 0,
  },
  {
    action: 'file-add',
    menuIcon: 'file-add',
    behavior: 'hide',
    types: ['actions', 'row'],
    menuText: 'actions.sent_file',
    minSelected: 0,
  },
  {
    action: 'remove',
    menuIcon: 'icon-remove',
    behavior: 'hide',
    types: ['actions', 'row'],
    menuText: 'actions.delete',
    minSelected: 0,
  },
];
